// extracted by mini-css-extract-plugin
export var checkbox = "_2g-0";
export var circle = "_2g-3";
export var horizontalContainer = "_2g-7";
export var sm = "_2g-5";
export var switch0 = "_2g-2";
export var switchDisabled = "_2g-8";
export var switchEnabled = "_2g-1";
export var textSwitchContainer = "_2g-9";
export var textSwitchOption = "_2g-a";
export var textSwitchOptionSelected = "_2g-b";
export var verticalContainer = "_2g-6";
export var xs = "_2g-4";